// Document module constants

// Table configuration
export const DOCUMENT_TABLE_CONFIG = {
  COLUMN_MIN_WIDTHS: {
    DOCUMENT: 100,
    CLINIC: 80,
    TYPE: 100,
    PROCESSING: 100,
    STATUS: 100,
    PATIENT: 120,
    CREATED: 50,
    ACTIONS: 100,
  },
  PAGINATION: {
    ROWS_PER_PAGE_OPTIONS: [10, 20, 50, 100],
    DEFAULT_PAGE: 1,
    DEFAULT_LIMIT: 20,
  },
  MAX_HEIGHT: 'calc(100vh - 300px)',
} as const;

// Document type colors
export const DOCUMENT_TYPE_COLORS = {
  REFERRAL_ORDER: {
    BACKGROUND: '#dbeafe',
    COLOR: '#1e40af',
    BORDER: '#1e40af',
  },
  PRIOR_AUTHORIZATION: {
    BACKGROUND: '#ecfdf5',
    COLOR: '#059669',
    BORDER: '#059669',
  },
  DEFAULT: {
    BACKGROUND: '#f8f9fa',
    COLOR: '#4b5563',
    BORDER: '#6b7280',
  },
} as const;

// Processing status colors

// Font weights
export const FONT_WEIGHTS = {
  LIGHT: '400',
  MEDIUM: '500',
  SEMIBOLD: '600',
} as const;

// Font sizes
export const FONT_SIZES = {
  CAPTION: '0.75rem',
  SMALL: '0.875rem',
} as const;

// Common text constants
export const TEXT_CONSTANTS = {
  UNKNOWN: 'Unknown',
  NO_PATIENT_DATA: 'No Patient Data',
  NO_CLINIC_ASSIGNED: 'No clinic assigned',
  CONFIDENCE_SUFFIX: '% confidence',
  DEFAULT_TABLE_TEXT: 'No documents found',
} as const;

// Confidence level colors
export const CONFIDENCE_COLORS = {
  HIGH: '#4caf50',    // >= 80%
  MEDIUM: '#ff9800',  // >= 60%
  LOW: '#f44336',     // < 60%
} as const;

// Common colors used throughout components
export const COMMON_COLORS = {
  INFO_BLUE: '#0891b2',
  NEUTRAL_GRAY: '#6b7280',
  ERROR_RED: '#dc2626',
  WHITE: '#ffffff',
  SUCCESS_GREEN: '#1eaf84',
  WARNING_ORANGE: '#ff9800',
} as const;

// API and processing constants
export const PROCESSING_CONSTANTS = {
  BATCH_SIZE: 16,
  RETRY_ATTEMPTS: 3,
  TIMEOUT_MS: 120000,
} as const;
